export default {
  brand: {
    primary: '#05e1aa',
    secondary: '#283237',
    tertiary: '#038766',
    quaternary: '#04bf91',
  },
};
